import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { CustomerInfoStyled } from "./styled";

const CustomerInfo = ({
  theme_standard,
  booker_first_name,
  booker_last_name,
  booker_email,
  booker_phone,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <CustomerInfoStyled className={customClass}>
      <div className="customer_info_row">
        <div className="customer_info_head">Firstname</div>
        <div className="customer_info_detail">{booker_first_name || "-"}</div>
      </div>
      <div className="customer_info_row">
        <div className="customer_info_head">Lastname</div>
        <div className="customer_info_detail">{booker_last_name || "-"}</div>
      </div>
      <div className="customer_info_row">
        <div className="customer_info_head">Email</div>
        <div className="customer_info_detail">{booker_email || "-"}</div>
      </div>
      <div className="customer_info_row">
        <div className="customer_info_head">Phone number</div>
        <div className="customer_info_detail">{booker_phone || "-"}</div>
      </div>
    </CustomerInfoStyled>
  );
};

CustomerInfo.propTypes = {};

export default CustomerInfo;
